'use strict';

import React, { Children } from 'react';
import ClassNameMixin from '../mixins/ClassNameMixin';
import BackColorMixin from '../mixins/BackColorMixin';
import PureRenderMixin from '../mixins/PureRenderMixin';

require('./TabBar.less');

var TabBar = React.createClass({
  mixins: [ClassNameMixin, BackColorMixin, PureRenderMixin],

  render: function () {
    return (
      <ul className={this.getClassName()}>
        {Children.map(this.props.children, this.renderTabBarItem)}
      </ul>
    );
  },

  renderTabBarItem: function (item, index) {
    return (
      <li key={index} className='TabBar-item'>
        {item}
      </li>
    );
  }
});

export default TabBar;


/** WEBPACK FOOTER **
 ** ./molecules/TabBar.jsx
 **/